export const DsTabsDefaultProps = {
    indicatorColor: 'secondary',
    textColor: 'secondary'
};
